export const root = "r8pk9lg";
export const content = "c1hoxk74";
export const iconAnimationContainer = "i5nxu1c";
export const iconAnimation = "i1ue6p49";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");